import {store as AppStore} from '../../store/store';
import {createLeadProvider, getLeadProviders} from '../../store/slices/lead_providers_slice.ts';
import {isFulfilled, isRejected} from '@reduxjs/toolkit';

const leadProviderName = 'PWA';
export async function getLeadProvider(store: typeof AppStore) {
    const leadProviders = await store.dispatch(getLeadProviders());

    if (isRejected(leadProviders)) {
        throw leadProviders.error;
    }

    if (isFulfilled(leadProviders) && !isRejected(leadProviders)) {
        const data = leadProviders.payload.leadProviders;

        const leadProvider = data?.find((provider) => provider?.name === leadProviderName);
        if (leadProvider) {
            return leadProvider.id;
        }

        const createdLeadProvider = await store.dispatch(createLeadProvider({name: leadProviderName}));

        if (isRejected(createdLeadProvider)) {
            throw createdLeadProvider.error;
        }

        if (isFulfilled(createdLeadProvider) && !isRejected(createdLeadProvider)) {
            if (createdLeadProvider.payload && createdLeadProvider.payload.createLeadProvider) {
                return createdLeadProvider.payload.createLeadProvider.id;
            }
        }

        return null;
    }
}
